import React from 'react'
import _ from 'lodash'
import { toast } from 'react-toastify'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import {
  fetchListing,
  updateListing,
  createListing,
  deleteListing,
} from '../../../modules/portal-remote/portalService'
import withLanguage from '../lang-select/withLanguage'
import ListingForm from './ListingForm'
import { bindActionCreators, compose } from 'redux'
import { setListing, initListing } from '../../../actions/listing'

class ListingDetailContainer extends React.Component {
  static defaultProps = {}

  constructor(props) {
    super(props)
    this.setListing = _.debounce(this.setListing, 500)
    this.setEditing = _.debounce(this.setEditing, 500)
  }

  state = {
    modifiedDate: null,
    listing: null,
    isEditing: false,
  }

  componentDidMount() {
    if (_.get(this.props, 'params.listingID')) {
      this.requestListing()
    } else {
      this.props.actions.initListing()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !this.state.isEditing &&
      !_.isEqual(
        this.props.listing.modifiedDate,
        prevProps.listing.modifiedDate,
      ) &&
      !_.isEqual(this.state.modifiedDate, this.props.listing.modifiedDate)
    ) {
      this.setEditing(true)
    }
  }

  componentWillUnmount() {
    this.props.actions.initListing()
  }

  requestListing = async _listingID => {
    const listingID = _listingID || _.get(this.props, 'params.listingID')
    try {
      const listing = await fetchListing(listingID)
      this.setListing(listing)
      this.setState({ modifiedDate: listing.modifiedDate, isEditing: false })
    } catch (error) {
      toast.error('requestListing ' + error.message)
    }
  }

  setEditing = isEditing => {
    this.setState({
      isEditing,
    })
  }

  setListing = (listing, modifiedDate) => {
    if (modifiedDate) {
      listing.modifiedDate = modifiedDate
    }
    this.props.actions.setListing(listing)
  }

  handleValidate = (values, props) => {
    this.setListing(values, new Date().toISOString()) //manage isEditing
    const errors = {}
    return errors
  }

  handleDelete = async () => {
    console.info('handle delete', this.state.listing)
    const message = `Are you sure to delete ${_.get(
      this.props,
      `listing.title.${this.props.language}`,
    )}`
    if (window.confirm(message)) {
      try {
        await deleteListing(this.props.listing._id)
        this.props.history.replace(
          `/towns/${this.props.match.params.townID}/listings`,
        )
        toast.success('Delete listing success.')
      } catch (error) {
        toast.error(error.message)
      }
    }
  }

  handleSubmit = async (values, actions) => {
    //for save to remote
    const listing = {
      ...values,
      mainImageId: this.props.listing.mainImageId,
      mainImageLastChecked: this.props.listing.mainImageLastChecked,
      portals: _.map(values.portals, portal => _.omit(portal, ['info'])),
    }

    try {
      if (listing._id) {
        await updateListing(listing)
        this.requestListing()
      } else {
        listing.town = _.get(this.props, 'params.townID')
        const result = await createListing(listing)
        this.props.history.replace(result._id)
      }

      toast.success(
        `Save listing ${_.get(
          listing,
          'title.' + this.props.language,
        )} success!!`,
      )
    } catch (error) {
      toast.error(error.message)
    }
    // console.log(listing, actions)
  }

  render() {
    const { listing } = this.props

    if (_.isEmpty(listing)) return null
    return (
      <ListingForm
        language={this.props.language}
        initialValues={this.props.listing}
        onValidate={this.handleValidate}
        onSubmit={this.handleSubmit}
        onDelete={this.handleDelete}
        isEditing={this.state.isEditing}
      />
    )
  }
}

export default compose(
  connect(
    ({ listing, town }) => ({ listing, town }),
    dispatch => ({
      actions: bindActionCreators(
        { setListing: setListing, initListing: initListing },
        dispatch,
      ),
    }),
  ),
  withLanguage,
  withRouter,
)(ListingDetailContainer)



// WEBPACK FOOTER //
// ./src/components/templates/listing-detail/ListingDetailContainer.js